import { render } from "./NftComponent.vue?vue&type=template&id=5dfd8b7f&scoped=true"
import script from "./NftComponent.vue?vue&type=script&lang=js"
export * from "./NftComponent.vue?vue&type=script&lang=js"

import "./NftComponent.vue?vue&type=style&index=0&id=5dfd8b7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dfd8b7f"]])

export default __exports__